export enum CaseStatusEnum {
    Start            = '00000530-1000-0000-0000-000000000001',
    Consult          = '00000530-1000-0000-0000-000000000002',
    Diagnose         = '00000530-1000-0000-0000-000000000003',
    Planning         = '00000530-1000-0000-0000-000000000004',
    Prep             = '00000530-1000-0000-0000-000000000005',
    Treatment        = '00000530-1000-0000-0000-000000000006',
    Reporting        = '00000530-1000-0000-0000-000000000007',
    Complete         = '00000530-1000-0000-0000-000000000008',
    Canceled         = '00000530-1000-0000-0000-000000000009',
    Pending          = '00000530-1000-0000-0000-000000000010'
  }